(function() {
    function Menu() {
        this.menuToggleMenu = function() {
            var $fullMenu = $('.js-fullmenuMenu');
            var $blurWrapper = $('.blurWrapper');
            var $html = $('html');
            var $topMenu = $('.topMenu');
            var $topMenuFixed = $('.topMenuFixed');
            var $topMenuHeight = $topMenu.height();
            var $firstColumn = $('.fullMenu__firstColumn', $fullMenu);
            var $secondColumn = $('.fullMenu__secondColumn', $fullMenu);
            $('.js-menuToggleMenu').on('click', function() {
                var $scrollLength = $(window).scrollTop();
                $blurWrapper.toggleClass('blurWrapper_blured');
                $html.toggleClass('m--html_overflowHidden');
                if ($firstColumn.is('.fadeInLeft')) {
                    $firstColumn.removeClass('fadeInLeft');
                    $firstColumn.addClass('fadeOutLeft');
                    $secondColumn.removeClass('fadeInRight');
                    $secondColumn.addClass('fadeOutRight');
                    window.setTimeout(function() {
                        $fullMenu.toggleClass('js-menuOpen');
                        if ($scrollLength > $topMenuHeight) {
                            $topMenuFixed.addClass('m--topMenuFixed_isShown');
                        }
                    }, 500);
                } else {
                    $firstColumn.removeClass('fadeOutLeft');
                    $firstColumn.addClass('fadeInLeft');
                    $secondColumn.removeClass('fadeOutRight');
                    $secondColumn.addClass('fadeInRight');
                    $fullMenu.toggleClass('js-menuOpen');
                    $topMenuFixed.removeClass('m--topMenuFixed_isShown');
                }
            });
        }

        this.menuToggleContact = function() {
            var $fullMenu = $('.js-fullmenuContacts');
            var $blurWrapper = $('.blurWrapper');
            var $html = $('html');
            var $topMenu = $('.topMenu');
            var $topMenuFixed = $('.topMenuFixed');
            var $topMenuHeight = $topMenu.height();
            var $firstColumn = $('.fullMenu__firstColumn', $fullMenu);
            var $secondColumn = $('.fullMenu__secondColumn', $fullMenu);
            $('.js-menuToggleContacts').on('click', function() {
                var $scrollLength = $(window).scrollTop();
                $blurWrapper.toggleClass('blurWrapper_blured');
                $html.toggleClass('m--html_overflowHidden');
                if ($firstColumn.is('.fadeInLeft')) {
                    $firstColumn.removeClass('fadeInLeft');
                    $firstColumn.addClass('fadeOutLeft');
                    $secondColumn.removeClass('fadeInRight');
                    $secondColumn.addClass('fadeOutRight');
                    window.setTimeout(function() {
                        $fullMenu.toggleClass('js-menuOpen');
                        if ($scrollLength > $topMenuHeight) {
                            $topMenuFixed.addClass('m--topMenuFixed_isShown');
                        }
                    }, 450);
                } else {
                    $firstColumn.removeClass('fadeOutLeft');
                    $firstColumn.addClass('fadeInLeft');
                    $secondColumn.removeClass('fadeOutRight');
                    $secondColumn.addClass('fadeInRight');
                    $fullMenu.toggleClass('js-menuOpen');
                    $topMenuFixed.removeClass('m--topMenuFixed_isShown');
                }
            });
        }

        this.fixedMenuScrolledToggle = function() {
            var $topMenu = $('.topMenu');
            var $topMenuFixed = $('.topMenuFixed');
            var $topMenuHeight = $topMenu.height();
            var $scrollLength;
            $(window).scroll(function() {
                $scrollLength = $(window).scrollTop();
                if ($scrollLength > $topMenuHeight) {
                    $topMenuFixed.addClass('m--topMenuFixed_isShown');
                } else {
                    $topMenuFixed.removeClass('m--topMenuFixed_isShown');
                }
            });
        }

        this.showHidenProjectContentToggle = function() {
            var $projectToggle = $('.projects .project');
            $($projectToggle).each(function() {
                element = this;
                var $children = $(this).children('.project__object');
                projectHeight = parseInt($(this).css('height'));
                $(window).resize(function(){
                    projectHeight = parseInt($(element).css('height'));   
                });
              
                var $childrenCount = $children.length;
                if ($childrenCount > 1) {
                    $(this).append('<div class="project__arrowSwitcher"></div>');
                    for (var i = 1, delay = 0.2; i < $childrenCount; i++, delay += 0.1) {
                        $children.eq(i).css('display', 'none').css('animation-delay', delay + 's').css('animation-duration', delay + 0.2 + 's');
                    }
                }
            });

            $projectToggle.on('click', function(e) {
                var $arrowswitcher = $('.project__arrowSwitcher', $(this));
                if ($(this).is('.m--project_hiddenContentShowed')) {
                    var $children = $(this).children('.project__object');
                    var $childrenCount = $children.length;
                    var childrenHeight = 0;
                    if ($childrenCount > 1) {
                        for (var i = 1; i < $childrenCount; i++) {
                            childrenHeight += parseInt($children.eq(i).css('height'));
                        }

                        for (var i = 1; i < $childrenCount; i++) {
                            $children.eq(i).removeClass('animated fadeInLeft').css('display', 'none');
                        }

                        $(this).animate({
                            height: projectHeight
                        }, 10);

                        $arrowswitcher.css('transform', 'rotate(0deg)');
                    }
                    $(this).removeClass('m--project_hiddenContentShowed');
                } else {
                    var $children = $(this).children('.project__object');
                    var $childrenCount = $children.length;
                    if ($childrenCount > 1) {
                        var childrenHeight = 0;
                        for (var i = 1; i < $childrenCount; i++) {                          
                            childrenHeight += parseInt($children.eq(i).css('height')) + parseInt($children.eq(i).css('margin-bottom'));
                        }

                        $(this).animate({
                            height: projectHeight + childrenHeight
                        }, 10);

                        for (var i = 1; i < $childrenCount; i++) {
                            $children.eq(i).css('display', 'block').addClass('animated fadeInLeft');
                        }
                    }
                    $arrowswitcher.css('transform', 'rotate(180deg)');
                    $(this).addClass('m--project_hiddenContentShowed');
                }
            });
        }

        this.showFullImageSliderInit = function() {
            var fullImageSwitcherButton = $('.js-fullImageSwitcher');
            var fullImageSwitcherWrapper = $('.js-fullImageSwitcherWrapper');
            var firstColumn = $('.js-fullImageSwitcherFirstColumn');
            var secondColumn = $('.js-fullImageSwitcherSecondColumn');
            var $photoGallery = $('.photoGallery');
            var $photoGallery__images = $('.photoGallery__images', $photoGallery);
        }

        this.projectsCounterInit = function() {
            var $projects = $('.project__object');
            var prevObjectId;
            var nextObjectId;
            var $openProjectInMainMenuButton = $('.js-openObjects');

            for (var i = 0; i < $projects.length; i++) {
                if (i==0) {
                    objectId = $($projects[0]).attr('data-projectId');
                    objectLinkId = $($projects[0]).attr('data-projectLinkId');
                    $openProjectInMainMenuButton.attr('data-objectId', objectId);
                    $openProjectInMainMenuButton.attr('data-projectLinkId', objectLinkId);
                    
                    if ($projects[i - 1]) {
                        prevObjectId = $($projects[i - 1]).attr('data-projectId');
                        prevObjectLinkId = $($projects[i - 1]).attr('data-projectLinkId');
                        $($projects[i]).attr('data-prevObjectId', prevObjectId);
                        $($projects[i]).attr('data-prevObjectLinkId', prevObjectLinkId);
                    } else {
                        prevObjectId = $($projects[$projects.length - 1]).attr('data-projectId');
                        prevObjectLinkId = $($projects[$projects.length - 1]).attr('data-projectLinkId');
                        $openProjectInMainMenuButton.attr('data-prevObjectId', prevObjectId);
                        $openProjectInMainMenuButton.attr('data-prevObjectLinkId', prevObjectLinkId);
                    }

                    if ($projects[i + 1]) {
                        nextObjectId = $($projects[i + 1]).attr('data-projectId');
                        nextObjectLinkId = $($projects[i + 1]).attr('data-projectLinkId');
                        $openProjectInMainMenuButton.attr('data-nextObjectId', nextObjectId);
                        $openProjectInMainMenuButton.attr('data-nextObjectLinkId', nextObjectLinkId);
                    } else {
                        nextObjectId = $($projects[0]).attr('data-projectId');
                        nextObjectLinkId = $($projects[0]).attr('data-projectLinkId');
                        $openProjectInMainMenuButton.attr('data-nextObjectId', nextObjectId);
                        $openProjectInMainMenuButton.attr('data-nextObjectLinkId', nextObjectLinkId);
                    }
                }

                if ($projects[i - 1]) {
                    prevObjectId = $($projects[i - 1]).attr('data-projectId');
                    prevObjectLinkId = $($projects[i - 1]).attr('data-projectLinkId');
                    $($projects[i]).attr('data-prevObjectId', prevObjectId);
                    $($projects[i]).attr('data-prevObjectLinkId', prevObjectLinkId);
                } else {
                    prevObjectId = $($projects[$projects.length - 1]).attr('data-projectId');
                    prevObjectLinkId = $($projects[$projects.length - 1]).attr('data-projectLinkId');
                    $($projects[i]).attr('data-prevObjectId', prevObjectId);
                    $($projects[i]).attr('data-prevObjectLinkId', prevObjectLinkId);
                }

                if ($projects[i + 1]) {
                    nextObjectId = $($projects[i + 1]).attr('data-projectId');
                    nextObjectLinkId = $($projects[i + 1]).attr('data-projectLinkId');
                    $($projects[i]).attr('data-nextObjectId', nextObjectId);
                    $($projects[i]).attr('data-nextObjectLinkId', nextObjectLinkId);
                } else {
                    nextObjectId = $($projects[0]).attr('data-projectId');
                    nextObjectLinkId = $($projects[0]).attr('data-projectLinkId');
                    $($projects[i]).attr('data-nextObjectId', nextObjectId);
                    $($projects[i]).attr('data-nextObjectLinkId', nextObjectLinkId);
                }
            }
        }

        this.openProjectShow = function() {
            var $projectDescriptionImMap = $('.map__objectDescription');
            var $projectObjectContext = $('.project');
            var $openProject = $('.openProject');
            var $openProjectInMainMenuButton = $('.js-openObjects');
            var $openProjectFirstColumn = $('.openProject__firstColumn', $openProject);
            var $openProjectSecondColumn = $('.openProject__secondColumn', $openProject);
            var $openProjectRegion = $('.openProject__region', $openProjectFirstColumn);
            var $openProjectName = $('.openProject__projectName', $openProjectFirstColumn);
            var $openProjectInnerContent = $('.openProject__innerContent', $openProjectFirstColumn);
            var $openProjectTextContent = $('.openProject__textContent', $openProjectFirstColumn);
            var $openProjectCloseButton = $('.openProject__closeButton', $openProjectFirstColumn);
            var $openProjectPrevProjectButton = $('.openProject__prevProjectButton', $openProject);
            var $openProjectNextProjectButton = $('.openProject__nextProjectButton', $openProject);
            var $openProjectPhotoSliderContent = $(".openProject__photoSliderContent", $openProject);
            var $fullImageSwitcherButton = $('.js-fullImageSwitcher');
            var $fullImageSwitcherWrapper = $('.js-fullImageSwitcherWrapper');
            var $projectObject = $('.project__object', $projectObjectContext );
            var $projectObjectInMap = $('.project__object', $projectDescriptionImMap);

            $openProjectCloseButton.on('click', function(e) {
                $('html').removeClass('m--html_overflowHidden');
                 e.stopPropagation();
                $openProjectInnerContent.removeClassWild('fade*');
                $openProjectPhotoSliderContent.removeClassWild('fade*');
                $openProjectFirstColumn.addClass('animated fadeOutLeft');
                $openProjectSecondColumn.addClass('animated fadeOutRight');

                window.setTimeout(function() {
                    $openProject.removeClass('js-openProject_isShown');
                    $openProjectFirstColumn.removeClass('animated fadeOutLeft');
                    $openProjectSecondColumn.removeClass('animated fadeOutRight');
                    $('.js-photoSlider').slick('unslick');
                    $(window).trigger('destroyGallery');
                }, 550);
            });

            $projectObject.on('click', function(e) {
                e.stopPropagation();
                $('html').addClass('m--html_overflowHidden');
                $projectObjectParent = $(this).parent();
                $openProjectInnerContent.removeClassWild('fade*');
                $openProjectPhotoSliderContent.removeClassWild('fade*');
                var $projectRegion = $('.project__region', $projectObjectParent);
                var $projectPhotoContent = $('.objectPhotoContent', $(this));
                $openProject.addClass('js-openProject_isShown');
                $openProjectRegion.html($projectRegion.html());
                $openProjectName.html($(this).html());
                $openProjectNextProjectButton.attr('data-nextObjectId', $(this).attr('data-nextObjectId'));
                $openProjectPrevProjectButton.attr('data-prevObjectId', $(this).attr('data-prevObjectId'));
                $openProjectNextProjectButton.attr('data-nextObjectLinkId', $(this).attr('data-nextObjectLinkId'));
                $openProjectPrevProjectButton.attr('data-prevObjectLinkId', $(this).attr('data-prevObjectLinkId'));
                $openProjectFirstColumn.addClass('animated fadeInLeft');
                $openProjectSecondColumn.addClass('animated fadeInRight');
                var sHandler = function(data) {
                    $('.openProject__spinnerPreloader').addClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                    $openProjectTextContent.html(data.textContent);
                    $openProjectPhotoSliderContent.removeClassWild('fade*');   
                    $openProjectPhotoSliderContent.css('opacity', '0');
                    $openProjectPhotoSliderContent.html(data.galleryContent);    
                
                    $('.photoSlider__item').imagesLoaded( { background: true }, function() {
                        $('.js-photoSlider').slick({
                            arrows: true,
                            dots: true,
                            speed: 500,
                            dots: false,
                            prevArrow: '<div class="photoSlider__arrowBefore"></div>',
                            nextArrow: '<div  class="photoSlider__arrowNext"></div>'
                        });
                        $('.openProject__spinnerPreloader').removeClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                        $openProjectPhotoSliderContent.css('opacity', '1');
                    });                      
                }

                var eHandler = function(response) {
                    alert('Произошла ошибка. Попробуйте перезагрузить страницу');
                }

                var params = 'objectLinkId='+$(this).attr('data-projectLinkId');
              
                $.ajax({
                    type     : 'post',
                    url      : '/json/',
                    data     : { _do: 'get_object_content',
                                 objectLinkId: $(this).attr('data-projectLinkId')

                     },
                    dataType : 'json',
                    timeout  : 3000,
                    success  : sHandler,
                    error    : eHandler
                });
            });

            $openProjectNextProjectButton.on('click', function(e) {
                e.stopPropagation();
                var $currentObjectID = $(this).attr('data-nextObjectId');
                var $currentObjectLinkID = $(this).attr('data-nextObjectLinkId');
                var $nextObject = $('.project__object[data-projectId=' + $(this).attr('data-nextObjectId') + ']');
                var $projectPhotoContent = $('.objectPhotoContent', $nextObject);
                $projectObjectParent = $nextObject.parent();
                var $projectRegion = $('.project__region', $projectObjectParent);
                $openProjectInnerContent.removeClassWild('fade*');
                $openProjectPhotoSliderContent.removeClassWild('fade*');

                if ($(window).width() < 1000){
                    $openProjectInnerContent.addClass(' animated fadeOutLeft');
                    $openProjectInnerContent.addClass('blured');
                    $openProjectPhotoSliderContent.css('opacity', '0');
                    $openProjectPhotoSliderContent.addClass('blured');
                }else{
                    $openProjectInnerContent.addClass(' animated fadeOutDown');
                    $openProjectInnerContent.addClass('blured');
                    $openProjectPhotoSliderContent.css('opacity', '0');
                    $openProjectPhotoSliderContent.addClass('blured');
                }

                window.setTimeout(function() {
                    $('.js-photoSlider').slick('unslick');
                    $openProjectInnerContent.removeClassWild('fade*');
                    $openProjectPhotoSliderContent.removeClassWild('fade*');
                    $openProjectInnerContent.removeClass('blured');
                    $openProjectPhotoSliderContent.removeClass('blured');
                    var sHandler = function(data) {
                        $('.openProject__spinnerPreloader').addClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                        $openProjectTextContent.html(data.textContent);
                        $openProjectPhotoSliderContent.removeClassWild('fade*');   
                        $openProjectPhotoSliderContent.css('opacity', '0');
                        $openProjectPhotoSliderContent.html(data.galleryContent);    
                        $('.photoSlider__item').imagesLoaded( { background: true }, function() {                              
                            $('.js-photoSlider').slick({
                                arrows: true,
                                dots: true,
                                speed: 500,
                                dots: false,
                                prevArrow: '<div class="photoSlider__arrowBefore"></div>',
                                nextArrow: '<div  class="photoSlider__arrowNext"></div>'
                            });
                            $('.openProject__spinnerPreloader').removeClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                            $openProjectPhotoSliderContent.css('opacity', '1');
                        });
                    }

                    var eHandler = function(response) {
                        alert('Произошла ошибка. Попробуйте перезагрузить страницу');
                    }

                    var params = 'objectLinkId='+$(this).attr('data-nextObjectLinkId');
                   
                    $.ajax({
                        type     : 'post',
                        url      : '/json/',
                        data     : { _do: 'get_object_content',
                                     objectLinkId: $currentObjectLinkID
                         },
                        dataType : 'json',
                        timeout  : 3000,
                        success  : sHandler,
                        error    : eHandler
                    });
                    $openProjectRegion.html($projectRegion.html());
                    $openProjectName.html($nextObject.html());

                    if ($(window).width() < 1000){
                        $openProjectInnerContent.addClass(' animated fadeInRight');                         
                    }else{
                        $openProjectInnerContent.addClass(' animated fadeInDown');
                    }

                    $openProjectNextProjectButton.attr('data-nextObjectId', $nextObject.attr('data-nextObjectId'));
                    $openProjectPrevProjectButton.attr('data-prevObjectId', $nextObject.attr('data-prevObjectId'));
                    $openProjectNextProjectButton.attr('data-nextObjectLinkId', $nextObject.attr('data-nextObjectLinkId'));
                    $openProjectPrevProjectButton.attr('data-prevObjectLinkId', $nextObject.attr('data-prevObjectLinkId'));
                }, 550);
            });

            $openProjectPrevProjectButton.on('click', function(e) {
                e.stopPropagation();
                var $currentObjectID = $(this).attr('data-prevObjectId');
                var $currentObjectLinkID = $(this).attr('data-prevObjectLinkId');
                var $prevObject = $('.project__object[data-projectId=' + $(this).attr('data-prevObjectId') + ']');
                var $projectPhotoContent = $('.objectPhotoContent', $prevObject);
                $projectObjectParent = $prevObject.parent();
                var $projectRegion = $('.project__region', $projectObjectParent);              
                $openProjectInnerContent.removeClassWild('fade*');
                $openProjectPhotoSliderContent.removeClassWild('fade*');
                $openProjectInnerContent.addClass('blured');

                if ($(window).width() < 1000){
                    $openProjectPhotoSliderContent.addClass('blured');
                    $openProjectInnerContent.addClass(' animated fadeOutRight');
                    $openProjectPhotoSliderContent.css('opacity', '0');
                }else{
                    $openProjectPhotoSliderContent.addClass('blured');
                    $openProjectInnerContent.addClass(' animated fadeOutUp');
                    $openProjectPhotoSliderContent.css('opacity', '0');
                }
              
                window.setTimeout(function() {
                    $('.js-photoSlider').slick('unslick');
                    
                    $openProjectInnerContent.removeClassWild('fade*');
                    $openProjectPhotoSliderContent.removeClassWild('fade*');
                    $openProjectInnerContent.removeClass('blured');
                    $openProjectPhotoSliderContent.removeClass('blured');
                    $openProjectRegion.html($projectRegion.html());
                    $openProjectName.html($prevObject.html());

                    var sHandler = function(data) {
                        $openProjectTextContent.html(data.textContent);
                        $openProjectPhotoSliderContent.removeClassWild('fade*');   
                        $openProjectPhotoSliderContent.css('opacity', '0');
                        $openProjectPhotoSliderContent.html(data.galleryContent);                               
                        $('.photoSlider__item').imagesLoaded( { background: true }, function() {                              
                            $('.js-photoSlider').slick({
                                arrows: true,
                                dots: true,
                                speed: 500,
                                dots: false,
                                prevArrow: '<div class="photoSlider__arrowBefore"></div>',
                                nextArrow: '<div  class="photoSlider__arrowNext"></div>'
                            });
                            $('.openProject__spinnerPreloader').removeClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                            $openProjectPhotoSliderContent.css('opacity', '1');
                        });
                    }

                    var eHandler = function(response) {
                        alert('Произошла ошибка. Попробуйте перезагрузить страницу');
                    }

                    var params = 'objectLinkId='+$(this).attr('data-nextObjectLinkId');
                    $.ajax({
                        type     : 'post',
                        url      : '/json/',
                        data     : { _do: 'get_object_content',
                                     objectLinkId: $currentObjectLinkID
                        },
                        dataType : 'json',
                        timeout  : 3000,
                        success  : sHandler,
                        error    : eHandler
                    });

                    if ($(window).width() < 1000){
                         $openProjectInnerContent.addClass(' animated fadeInLeft');
                         
                    }else{
                        $openProjectInnerContent.addClass(' animated fadeInUp');                          
                    }
                    $openProjectPrevProjectButton.attr('data-prevObjectId', $prevObject.attr('data-prevObjectId'));
                    $openProjectNextProjectButton.attr('data-nextObjectId', $prevObject.attr('data-nextObjectId'));
                    $openProjectNextProjectButton.attr('data-nextObjectLinkId', $prevObject.attr('data-nextObjectLinkId'));
                    $openProjectPrevProjectButton.attr('data-prevObjectLinkId', $prevObject.attr('data-prevObjectLinkId'));
                }, 550);
            });

            $openProjectInMainMenuButton.on('click', function(event){
                event.preventDefault();
                var $fullMenu = $('.js-fullmenuMenu');
                var $blurWrapper = $('.blurWrapper');
                var $html = $('html');
                var $topMenu = $('.topMenu');
                var $topMenuFixed = $('.topMenuFixed');
                var $topMenuHeight = $topMenu.height();
                var $firstColumn = $('.fullMenu__firstColumn', $fullMenu);
                var $secondColumn = $('.fullMenu__secondColumn', $fullMenu);
                var $projects = $('.project__object');
                var $scrollLength = $(window).scrollTop();
                $blurWrapper.toggleClass('blurWrapper_blured');
                $html.addClass('m--html_overflowHidden');
                if ($firstColumn.is('.fadeInLeft')) {
                    $firstColumn.removeClass('fadeInLeft');
                    $firstColumn.addClass('fadeOutLeft');
                    $secondColumn.removeClass('fadeInRight');
                    $secondColumn.addClass('fadeOutRight');
                    window.setTimeout(function() {
                        $fullMenu.toggleClass('js-menuOpen');
                        if ($scrollLength > $topMenuHeight) {
                            $topMenuFixed.addClass('m--topMenuFixed_isShown');
                        }
                    }, 500);
                } else {
                    $firstColumn.removeClass('fadeOutLeft');
                    $firstColumn.addClass('fadeInLeft');
                    $secondColumn.removeClass('fadeOutRight');
                    $secondColumn.addClass('fadeInRight');
                    $fullMenu.toggleClass('js-menuOpen');
                    $topMenuFixed.removeClass('m--topMenuFixed_isShown');
                }
                $projectObjectParent = $($projects[0]).parent();
                $openProjectInnerContent.removeClassWild('fade*');
                $openProjectPhotoSliderContent.removeClassWild('fade*');

                var $projectRegion = $('.project__region', $projectObjectParent);
                var $projectPhotoContent = $('.objectPhotoContent', $($projects[0]));
                $openProject.addClass('js-openProject_isShown');
                $openProjectRegion.html($projectRegion.html());
                $openProjectName.html($($projects[0]).html());
                $openProjectNextProjectButton.attr('data-nextObjectId', $($projects[0]).attr('data-nextObjectId'));
                $openProjectPrevProjectButton.attr('data-prevObjectId', $($projects[0]).attr('data-prevObjectId'));
                $openProjectNextProjectButton.attr('data-nextObjectLinkId', $($projects[0]).attr('data-nextObjectLinkId'));
                $openProjectPrevProjectButton.attr('data-prevObjectLinkId', $($projects[0]).attr('data-prevObjectLinkId'));
                $openProjectFirstColumn.addClass('animated fadeInLeft');
                $openProjectSecondColumn.addClass('animated fadeInRight');
                var sHandler = function(data) {
                    $openProjectTextContent.html(data.textContent);
                    $openProjectPhotoSliderContent.removeClassWild('fade*');   
                    $openProjectPhotoSliderContent.css('opacity', '0');
                    $openProjectPhotoSliderContent.html(data.galleryContent);
                   
                    $('.photoSlider__item').imagesLoaded( { background: true }, function() {
                        $('.js-photoSlider').slick({
                            arrows: true,
                            dots: true,
                            speed: 500,
                            dots: false,
                            prevArrow: '<div class="photoSlider__arrowBefore"></div>',
                            nextArrow: '<div  class="photoSlider__arrowNext"></div>'
                        });
                        $('.openProject__spinnerPreloader').removeClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                        $openProjectPhotoSliderContent.css('opacity', '1');
                    });             
                }
                var eHandler = function(response) {
                    alert('Произошла ошибка. Попробуйте перезагрузить страницу');
                }
                var params = 'objectLinkId='+$($projects[0]).attr('data-projectLinkId');  
                $.ajax({
                    type     : 'post',
                    url      : '/json/',
                    data     : { _do: 'get_object_content',
                                 objectLinkId: $($projects[0]).attr('data-projectLinkId')
                     },
                    dataType : 'json',
                    timeout  : 3000,
                    success  : sHandler,
                    error    : eHandler
                });    
             });

            $fullImageSwitcherButton.on('click', function() {
                var fullImageSwitcherWrapper = $('.js-fullImageSwitcherWrapper');
                var viewer = new Viewer(document.querySelector('.openProject__photoSliderContent .photoGallery__images'));
                document.querySelector('.openProject__photoSliderContent .photoGallery__images').addEventListener('viewed', function() {
                    fullImageSwitcherWrapper.addClass('js-openProject_blured');
                }, false);
                document.querySelector(' .openProject__photoSliderContent .photoGallery__images').addEventListener('hide', function() {
                    fullImageSwitcherWrapper.removeClass('js-openProject_blured')
                    viewer.destroy();
                }, false);

                $(window).on('destroyGallery', function() {
                    viewer.destroy();
                });
                viewer.show();
            });
        }
    }
    proj.menu = new Menu();
})();